"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7118],{

/***/ 25242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q6": function() { return /* binding */ GoldCard; },
/* harmony export */   "SU": function() { return /* binding */ fmtChi; },
/* harmony export */   "iT": function() { return /* binding */ Delta; }
/* harmony export */ });
/* unused harmony export pickCardRows */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);



/** Định dạng nghìn đồng/chỉ: 14180 → "14,180" (như app) */ var fmtChi = function(n) {
    return n ? n.toLocaleString("en-US") : "—";
};
var Delta = function(param) {
    var value = param.value;
    return value ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: "tw-block tw-text-[11px] tw-leading-tight tw-mt-0.5 ".concat(value > 0 ? "tw-text-[#219B64]" : "tw-text-[#C0392B]"),
        children: [
            value > 0 ? "▲ +" : "▼ −",
            Math.abs(value).toLocaleString("en-US")
        ]
    }) : null;
};
var CARD_KEYS = [
    "BTMC VRTL",
    "PNJ TP.HCM",
    "SJC"
];
var pickCardRows = function(gold) {
    var rows = CARD_KEYS.map(function(k) {
        return gold.rows.find(function(r) {
            return r.name === k;
        });
    }).filter(Boolean);
    return rows.length ? rows : gold.rows.slice(0, 3);
};
/**
 * Thẻ giá vàng dùng chung (thiết kế an-thu-ui-update).
 * variant "card": trang chủ (có tiêu đề + nút xem đầy đủ). variant "band": khối trong /tin-tuc/ (chỉ bảng, cột căn giữa).
 */ var GoldCard = function(param) {
    var gold = param.gold, _className = param.className, className = _className === void 0 ? "" : _className, _variant = param.variant, variant = _variant === void 0 ? "card" : _variant;
    var band = variant === "band";
    var cols = band ? "tw-grid-cols-[1fr_84px_84px] sm:tw-grid-cols-[1fr_130px_130px] tw-text-center" : "tw-grid-cols-[1fr_64px_64px]";
    var num = band ? "tw-text-center" : "tw-text-right";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "tw-bg-white tw-border tw-border-solid tw-border-[#DECA95] tw-text-[#30220E] ".concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "tw-p-4 tw-pb-3",
                children: [
                    !band && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "tw-m-0 tw-border-0 tw-border-l-[3px] tw-border-solid tw-border-[#AF9454] tw-pl-3 tw-text-[15px] tw-font-bold tw-uppercase tw-leading-tight",
                        children: "Gi\xe1 v\xe0ng h\xf4m nay"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "tw-m-0 ".concat(band ? "" : "tw-mt-2 tw-text-[#AF9454]", " tw-text-[13px]"),
                        children: "Ngh\xecn đồng/chỉ"
                    })
                ]
            }),
            gold ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "tw-grid ".concat(cols, " tw-gap-x-2 tw-bg-[#FEF8E0] tw-px-4 tw-py-3 tw-text-[13px] ").concat(band ? "tw-text-[#AF9454] tw-text-[14px]" : "tw-text-[#AF9454] tw-text-[11px]"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "tw-text-left",
                                children: "Sản phẩm"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: band ? "" : "tw-text-right",
                                children: "Mua v\xe0o"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: band ? "" : "tw-text-right",
                                children: "B\xe1n ra"
                            })
                        ]
                    }),
                    pickCardRows(gold).map(function(r) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "tw-grid ".concat(cols, " tw-gap-x-2 tw-items-start tw-px-4 tw-py-3 tw-text-[13px] ").concat(band ? "tw-border-0 tw-border-b tw-border-solid tw-border-[#DECA95]/40 tw-text-[15px]" : ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "tw-pt-0.5 tw-text-left",
                                    children: r.name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "".concat(num, " ").concat(band ? "" : "tw-font-bold"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: band ? "tw-font-medium" : "",
                                            children: fmtChi(r.buy)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Delta, {
                                            value: r.buyDelta
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "".concat(num, " ").concat(band ? "" : "tw-font-bold"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: band ? "tw-font-medium" : "",
                                            children: fmtChi(r.sell)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Delta, {
                                            value: r.sellDelta
                                        })
                                    ]
                                })
                            ]
                        }, r.key);
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "tw-m-0 tw-bg-[#FEF8E0] tw-px-4 tw-py-3 tw-text-[12px] tw-text-[#AF9454]",
                        children: [
                            gold.source,
                            " \xb7 ",
                            gold.updatedAt
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "tw-m-0 tw-bg-[#FEF8E0] tw-px-4 tw-py-6 tw-text-[13px] tw-text-[#AF9454]",
                children: "Chưa c\xf3 dữ liệu gi\xe1 v\xe0ng. Vui l\xf2ng quay lại sau \xedt ph\xfat."
            }),
            !band && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-p-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: "/bang-gia/gia-vang/",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "tw-flex tw-min-h-[40px] tw-items-center tw-justify-center tw-bg-[#0F6656] tw-text-[13px] tw-font-medium !tw-text-white hover:!tw-text-white",
                        children: "Xem đầy đủ gi\xe1 v\xe0ng →"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 77118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ JournalTopicLayout; },
/* harmony export */   "n": function() { return /* binding */ JournalHomeLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42031);
/* harmony import */ var _components_ui_JsonLd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59904);
/* harmony import */ var _constants_business__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56154);
/* harmony import */ var _const__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89365);
/* harmony import */ var _promo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30334);
/* harmony import */ var _gold_card__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25242);
/* harmony import */ var _market_pages__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71744);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41046);










var SITE = _constants_business__WEBPACK_IMPORTED_MODULE_2__/* .BUSINESS.appUrl */ .aL.appUrl;
var JournalHomeLayout = function(param) {
    var picks = param.picks, q = param.q, results = param.results, _reels = param.reels, reels = _reels === void 0 ? [] : _reels, _promoImages = param.promoImages, promoImages = _promoImages === void 0 ? {} : _promoImages, _promos = param.promos, promos = _promos === void 0 ? _promo__WEBPACK_IMPORTED_MODULE_3__/* .PROMOS */ .e : _promos, _gold = param.gold, gold = _gold === void 0 ? null : _gold, _latest = param.latest, latest = _latest === void 0 ? [] : _latest, _articles = param.articles, articles = _articles === void 0 ? [] : _articles;
    // Tin mới (chuyên mục Tin Tức trên anthu.today) — tự hiện khi đăng bài, không cần sửa PROMOS
    var promoSlugs = new Set(promos.map(function(p) {
        return p.article;
    }));
    var news = latest.filter(function(a) {
        return !a.press && !a.promotion && !promoSlugs.has(a.slug);
    }).slice(0, 3);
    var searching = q.trim().length > 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .JournalShell */ .C2, {
        activeKey: "kien-thuc",
        query: q,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                title: "Kiến thức kim cương, trang sức & tin tức",
                description: "Kiến thức kim cương, cảm hứng trang sức v\xe0 những c\xe2u chuyện mới nhất từ An Thư The Diamond Store.",
                image: "".concat(SITE, "/logo-bg.png"),
                noindex: searching
            }),
            !searching && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_JsonLd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                schema: [
                    {
                        "@context": "https://schema.org",
                        "@type": "CollectionPage",
                        "@id": "".concat(SITE, "/tin-tuc/#page"),
                        url: "".concat(SITE, "/tin-tuc/"),
                        name: "Kiến thức kim cương, trang sức & tin tức | An Thư",
                        inLanguage: "vi",
                        publisher: {
                            "@id": _constants_business__WEBPACK_IMPORTED_MODULE_2__/* .BUSINESS.id */ .aL.id
                        },
                        hasPart: _const__WEBPACK_IMPORTED_MODULE_7__/* .PAGE_TOPICS.map */ .IO.map(function(t) {
                            return {
                                "@type": "CollectionPage",
                                name: t.title,
                                url: "".concat(SITE).concat((0,_const__WEBPACK_IMPORTED_MODULE_7__/* .topicHref */ .hR)(t.slug))
                            };
                        })
                    },
                    {
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        itemListElement: [
                            {
                                "@type": "ListItem",
                                position: 1,
                                name: "Trang chủ",
                                item: SITE
                            },
                            {
                                "@type": "ListItem",
                                position: 2,
                                name: "Tin tức",
                                item: "".concat(SITE, "/tin-tuc/")
                            }, 
                        ]
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Breadcrumb */ .aG, {
                items: [
                    {
                        label: "Trang chủ",
                        href: "/"
                    },
                    {
                        label: "Tin tức"
                    }
                ],
                back: false,
                searchQuery: q
            }),
            searching ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Section */ .$0, {
                id: "ket-qua-tim-kiem",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .SectionHead */ .Ry, {
                        eyebrow: "T\xccM KIẾM",
                        title: "Kết quả cho “".concat(q, "”"),
                        lead: "".concat(results.length, " b\xe0i viết ph\xf9 hợp.")
                    }),
                    results.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .ArticleGrid */ .dz, {
                        items: results
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "tw-text-jr-mute",
                        children: "Chưa c\xf3 b\xe0i ph\xf9 hợp. Thử từ kho\xe1 kh\xe1c như “kiểm định”, “nhẫn cưới”, “bảo quản”."
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "tw-bg-jr-band",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "tw-mx-auto tw-w-full tw-max-w-[1296px] tw-px-5 md:tw-px-8 tw-grid tw-items-center tw-gap-8 md:tw-grid-cols-[1.2fr_0.8fr] tw-py-10 md:tw-py-14",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Eyebrow */ .j4, {
                                            children: "G\xd3C AN THƯ"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "tw-sr-only",
                                            children: "Tin tức & kiến thức kim cương, trang sức, đ\xe1 qu\xfd – G\xf3c An Thư"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            "aria-hidden": "true",
                                            className: "tw-font-jr tw-mt-4 tw-mb-0 tw-text-[34px] md:tw-text-[52px] lg:tw-text-[56px] tw-font-normal tw-leading-[1.15] [text-wrap:balance]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "tw-block",
                                                    children: "Hiểu gi\xe1 trị."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "tw-block md:tw-whitespace-nowrap",
                                                    children: "Chọn điều xứng đ\xe1ng."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "tw-mt-5 tw-mb-0 tw-max-w-[540px] tw-text-[17px] md:tw-text-[19px] tw-text-jr-mute tw-leading-relaxed",
                                            children: "Kiến thức kim cương, cảm hứng trang sức v\xe0 những c\xe2u chuyện mới nhất từ An Thư."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tw-mt-8",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                                                href: "#bai-viet",
                                                children: "Kh\xe1m ph\xe1 b\xe0i viết"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "tw-flex tw-justify-center md:tw-justify-end",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/journal/hero-ring.jpg",
                                        alt: "Nhẫn kim cương An Thư",
                                        width: 520,
                                        height: 520,
                                        className: "tw-w-full tw-max-w-[460px] tw-aspect-square tw-object-cover"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Section */ .$0, {
                        id: "chuyen-de",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .SectionHead */ .Ry, {
                                title: "Bạn muốn t\xecm hiểu điều g\xec?",
                                lead: "S\xe1u chuy\xean đề gi\xfap bạn đi từ t\xecm hiểu đến lựa chọn."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .TopicsGrid */ .TT, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Section */ .$0, {
                        className: "!tw-pt-4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "tw-grid tw-gap-8 md:tw-grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] md:tw-items-center tw-bg-[#EFEFEF] tw-p-6 md:tw-p-12",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Eyebrow */ .j4, {
                                            children: "GI\xc1 V\xc0NG & THỊ TRƯỜNG"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "tw-font-jr tw-mt-4 tw-mb-0 tw-text-[32px] md:tw-text-[44px] tw-font-normal tw-leading-[1.2]",
                                            children: "Gi\xe1 v\xe0ng h\xf4m nay."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "tw-mt-4 tw-mb-0 tw-text-[17px] tw-text-jr-mute",
                                            children: "Gi\xe1 mua v\xe0o, b\xe1n ra theo thương hiệu."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "tw-mt-6 tw-mb-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__.A, {
                                                href: "/tin-tuc/vang-bao-quan/",
                                                className: "tw-text-[16px] tw-font-medium tw-text-jr-green hover:tw-underline",
                                                children: "V\xe0ng 14K \xb7 18K \xb7 24K →"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tw-mt-6",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                                                href: "/bang-gia/",
                                                className: "md:tw-min-w-[360px]",
                                                children: "Xem đầy đủ gi\xe1 v\xe0ng →"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_gold_card__WEBPACK_IMPORTED_MODULE_8__/* .GoldCard */ .Q6, {
                                    gold: gold,
                                    variant: "band"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Section */ .$0, {
                        className: "!tw-pt-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "tw-mb-8 tw-flex tw-flex-wrap tw-items-end tw-justify-between tw-gap-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Eyebrow */ .j4, {
                                                children: "G\xd3C AN THƯ"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "tw-font-jr tw-mt-2 tw-mb-0 tw-text-[28px] md:tw-text-[40px] tw-font-normal tw-leading-[1.2]",
                                                children: "Ưu đ\xe3i tại An Thư"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__.A, {
                                        href: "/tin-tuc/khuyen-mai/",
                                        className: "tw-text-[15px] tw-font-medium tw-text-jr-green hover:tw-underline",
                                        children: "Xem tất cả Khuyến m\xe3i →"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "tw-grid tw-gap-5 md:tw-grid-cols-2",
                                children: promos.filter(function(p) {
                                    return !p.ended;
                                }).map(function(p) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "tw-grid tw-grid-cols-[minmax(0,42%)_1fr] tw-items-center tw-gap-5 md:tw-gap-8 tw-border tw-border-solid tw-border-[#DECA95] tw-bg-[#FEFCEF] tw-p-3 md:tw-p-5",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__.A, {
                                                href: "/article/".concat(p.article, "/"),
                                                className: "tw-block",
                                                children: promoImages[p.slug] ? // eslint-disable-next-line @next/next/no-img-element
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: promoImages[p.slug],
                                                    alt: p.short,
                                                    width: 1080,
                                                    height: 1350,
                                                    loading: "lazy",
                                                    className: "tw-w-full tw-h-auto tw-aspect-[4/5] tw-object-cover"
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "tw-aspect-[4/5] tw-w-full tw-bg-jr-band"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        className: "tw-font-jr tw-m-0 tw-text-[24px] md:tw-text-[34px] tw-font-normal tw-leading-[1.2] tw-text-jr-green",
                                                        children: p.short
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "tw-mt-4 tw-mb-0 tw-whitespace-pre-line tw-text-[15px] md:tw-text-[18px] tw-text-jr-mute",
                                                        children: p.period.replace(/^Áp dụng từ (\S+) đến /, "\xc1p dụng từ $1\nĐến ").replace(/\.$/, "").replace(/ - /, " – ")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "tw-mt-4 tw-mb-0",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "tw-inline-block tw-bg-[#F1E6C4] tw-px-3 tw-py-1.5 tw-text-[14px] tw-text-[#8a7340]",
                                                            children: "Đang diễn ra"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__.A, {
                                                        href: "/article/".concat(p.article, "/"),
                                                        className: "tw-mt-5 tw-inline-flex tw-min-h-[48px] tw-items-center tw-bg-jr-green tw-px-6 tw-text-[15px] tw-font-medium tw-text-white hover:tw-opacity-90",
                                                        children: [
                                                            p.shortCta || p.cta,
                                                            " →"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, p.slug);
                                })
                            })
                        ]
                    }),
                    news.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Section */ .$0, {
                        className: "!tw-pt-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "tw-mb-8 tw-flex tw-flex-wrap tw-items-end tw-justify-between tw-gap-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Eyebrow */ .j4, {
                                                children: "MỚI NHẤT"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "tw-font-jr tw-mt-2 tw-mb-0 tw-text-[28px] md:tw-text-[40px] tw-font-normal tw-leading-[1.2]",
                                                children: "Tin mới từ An Thư"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__.A, {
                                        href: "/tin-tuc/tin-an-thu/",
                                        className: "tw-text-[15px] tw-font-medium tw-text-jr-green hover:tw-underline",
                                        children: "Xem tất cả →"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "tw-grid tw-gap-x-5 tw-gap-y-10 sm:tw-grid-cols-2 lg:tw-grid-cols-3",
                                children: news.map(function(a) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .ArticleCard */ .Tn, {
                                        a: a,
                                        fit: "poster",
                                        showDate: true
                                    }, a.id);
                                })
                            })
                        ]
                    }),
                    (articles.length > 0 || picks.length > 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Section */ .$0, {
                        id: "bai-viet",
                        className: "!tw-pt-4 tw-scroll-mt-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .SectionHead */ .Ry, {
                                title: "B\xe0i viết mới nhất"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "tw-grid tw-gap-x-5 tw-gap-y-10 sm:tw-grid-cols-2 lg:tw-grid-cols-3",
                                children: (articles.length ? articles : picks).map(function(a) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .ArticleCard */ .Tn, {
                                        a: a
                                    }, a.id);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Section */ .$0, {
                        className: "!tw-pt-4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "tw-grid tw-gap-8 tw-items-center tw-bg-[#0b0b0b] tw-text-white tw-p-6 md:tw-p-10 ".concat(reels.length ? "md:tw-grid-cols-[1fr_auto_auto]" : ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Eyebrow */ .j4, {
                                            children: "AN THƯ REELS"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                            className: "tw-font-jr tw-mt-4 tw-mb-0 tw-text-[28px] tw-font-normal tw-leading-[1.2] md:tw-text-[36px] tw-text-white",
                                            children: [
                                                "Chi\xeam ngưỡng",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                " trang sức chuyển động."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "tw-mt-6 tw-mb-0 tw-text-[16px] tw-text-[#d7d3c8]",
                                            children: reels.length ? "Hai g\xf3c nh\xecn thật từ An Thư. Chọn video để xem trọn vẹn vẻ đẹp." : "Ảnh v\xe0 video thật từ An Thư."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tw-mt-8",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                                                href: "/reels/",
                                                tone: "gold",
                                                children: "Xem tất cả video"
                                            })
                                        })
                                    ]
                                }),
                                reels.map(function(r) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__.A, {
                                        href: "/reels/?v=".concat(r.id),
                                        className: "tw-group tw-block tw-w-full md:tw-w-[210px] lg:tw-w-[250px] tw-border tw-border-[#2a2a2a] tw-p-3",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "tw-relative",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: r.cover,
                                                        alt: "Video ".concat(r.title),
                                                        loading: "lazy",
                                                        className: "tw-aspect-[3/4] tw-w-full tw-object-cover"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "tw-absolute tw-left-1/2 tw-top-1/2 tw-flex tw-h-12 tw-w-12 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-white tw-bg-black/40 tw-text-white",
                                                        children: "▶"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "tw-mt-4 tw-mb-0 tw-text-[14px] tw-text-white",
                                                children: r.title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "tw-mt-3 tw-mb-0 tw-text-[13px] tw-text-[#d7d3c8] group-hover:tw-underline",
                                                children: "Xem video →"
                                            })
                                        ]
                                    }, r.id);
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .ExploreMore */ .hf, {})
                ]
            })
        ]
    });
};
var JournalTopicLayout = function(param) {
    var slug = param.slug, articles = param.articles;
    var topic = _const__WEBPACK_IMPORTED_MODULE_7__/* .TOPIC_BY_SLUG */ .wp[slug];
    var navKey = [
        "kim-cuong",
        "trang-suc"
    ].includes(topic.slug) ? topic.slug : "kien-thuc";
    var url = "".concat(SITE).concat((0,_const__WEBPACK_IMPORTED_MODULE_7__/* .topicHref */ .hR)(topic.slug));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .JournalShell */ .C2, {
        activeKey: navKey,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                title: topic.seoTitle,
                description: topic.seoDescription,
                image: "".concat(SITE, "/logo-bg.png")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_JsonLd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                schema: [
                    {
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        itemListElement: [
                            {
                                "@type": "ListItem",
                                position: 1,
                                name: "Trang chủ",
                                item: SITE
                            },
                            {
                                "@type": "ListItem",
                                position: 2,
                                name: "Tin tức",
                                item: "".concat(SITE, "/tin-tuc/")
                            },
                            {
                                "@type": "ListItem",
                                position: 3,
                                name: topic.title,
                                item: url
                            }, 
                        ]
                    },
                    {
                        "@context": "https://schema.org",
                        "@type": "CollectionPage",
                        "@id": "".concat(url, "#page"),
                        name: topic.seoTitle,
                        description: topic.seoDescription,
                        url: url,
                        inLanguage: "vi",
                        publisher: {
                            "@id": _constants_business__WEBPACK_IMPORTED_MODULE_2__/* .BUSINESS.id */ .aL.id
                        },
                        mainEntity: {
                            "@id": "".concat(url, "#articles")
                        }
                    },
                    {
                        "@context": "https://schema.org",
                        "@type": "ItemList",
                        "@id": "".concat(url, "#articles"),
                        name: "B\xe0i viết về ".concat(topic.title.toLowerCase()),
                        itemListElement: articles.slice(0, 12).map(function(a, i) {
                            return {
                                "@type": "ListItem",
                                position: i + 1,
                                url: "".concat(SITE, "/article/").concat(a.slug, "/"),
                                name: a.title
                            };
                        })
                    },
                    {
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        "@id": "".concat(url, "#faq"),
                        url: url,
                        inLanguage: "vi",
                        mainEntity: topic.faq.map(function(f) {
                            return {
                                "@type": "Question",
                                name: f.q,
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: f.a
                                }
                            };
                        })
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Breadcrumb */ .aG, {
                items: [
                    {
                        label: "Trang chủ",
                        href: "/"
                    },
                    {
                        label: "Tin tức",
                        href: "/tin-tuc/"
                    },
                    {
                        label: topic.title
                    }
                ]
            }),
            topic.slug === "trang-suc" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TrangSucHero, {
                topic: topic
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .TopicHero */ .MP, {
                topic: topic
            }),
            (topic.slug === "kim-cuong" || topic.slug === "kiem-dinh") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Section */ .$0, {
                className: "!tw-py-0 tw-mt-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-gap-4 tw-bg-jr-band tw-p-5 md:tw-flex-row md:tw-items-center md:tw-justify-between md:tw-px-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "tw-m-0 tw-text-[16px] tw-text-jr-ink",
                            children: "Đ\xe3 c\xf3 số b\xe1o c\xe1o? Đối chiếu th\xf4ng tin vi\xean đ\xe1 tr\xean GIA."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                            href: _market_pages__WEBPACK_IMPORTED_MODULE_9__/* .GIA_LOOKUP_HREF */ .QZ,
                            className: "tw-shrink-0",
                            children: "Tra cứu GIA"
                        })
                    ]
                })
            }),
            topic.blocks.map(function(b, i) {
                return (0,_components__WEBPACK_IMPORTED_MODULE_4__/* .renderBlock */ ._2)(b, {
                    topic: topic,
                    articles: articles,
                    key: i
                });
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .FaqSection */ .o4, {
                items: topic.faq
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .ExploreMore */ .hf, {
                exclude: topic.slug
            })
        ]
    });
};
var TrangSucHero = function(param) {
    var topic = param.topic;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-mx-auto tw-w-full tw-max-w-[1296px] tw-px-5 md:tw-px-8 tw-pt-6 md:tw-pt-8 tw-pb-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Eyebrow */ .j4, {
                    children: topic.hero.eyebrow
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "tw-font-jr tw-mt-4 tw-mb-0 tw-text-[34px] md:tw-text-[56px] tw-font-normal tw-leading-[1.15]",
                    children: topic.hero.title.join(" ")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "tw-mt-4 tw-mb-0 tw-text-[17px] md:tw-text-[19px] tw-text-jr-mute",
                    children: topic.hero.lead
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-mt-10 tw-grid tw-gap-4 md:tw-grid-cols-[1fr_1fr]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/journal/necklace.jpg",
                            alt: "D\xe2y chuyền kim cương",
                            className: "tw-w-full tw-aspect-square tw-object-cover tw-bg-black"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "tw-grid tw-gap-4 tw-grid-rows-[auto_1fr]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/journal/earrings.jpg",
                                    alt: "B\xf4ng tai kim cương",
                                    className: "tw-w-full tw-aspect-[16/10] tw-object-cover tw-bg-black"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "tw-bg-jr-band tw-p-8 md:tw-p-10",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Eyebrow */ .j4, {
                                            children: "CẢM HỨNG PHONG C\xc1CH"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "tw-font-jr tw-mt-4 tw-mb-0 tw-text-[28px] md:tw-text-[34px] tw-leading-[1.2]",
                                            children: [
                                                "Thanh lịch trong",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                " từng lựa chọn."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 30334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ PROMOS; }
/* harmony export */ });
/**
 * Chương trình khuyến mãi hiển thị ở /tin-tuc/khuyen-mai/ và khối "Ưu đãi tại An Thư" của /tin-tuc/.
 * Nội dung theo bản thiết kế 12/10/2026. Muốn đổi chương trình / thời gian / link: sửa ở file này.
 * Ảnh poster lấy từ ảnh đại diện của bài tương ứng trên anthu.today (slug bên dưới).
 */ var PROMOS = [
    {
        slug: "thang-10-tron-ven",
        article: "thang-10-tron-ven",
        ended: false,
        status: "ĐANG DIỄN RA",
        title: "Th\xe1ng 10\ntrọn vẹn.",
        short: "Th\xe1ng 10 trọn vẹn",
        period: "01 - 31/10/2026",
        validFrom: "2026-10-01",
        validThrough: "2026-10-31",
        desc: "Một th\xe1ng để chọn m\xf3n trang sức y\xeau th\xedch, với hai lựa chọn ưu đ\xe3i theo chương tr\xecnh.",
        highlights: [
            {
                value: "15%",
                label: "Ưu đ\xe3i theo chương tr\xecnh"
            },
            {
                value: "70 triệu",
                label: "Qu\xe0 tặng tối đa"
            }, 
        ],
        note: "Lựa chọn ưu đ\xe3i theo gi\xe1 trị đơn h\xe0ng v\xe0 điều kiện được An Thư c\xf4ng bố.",
        cta: "Xem điều kiện chương tr\xecnh",
        shortCta: "Xem chương tr\xecnh"
    },
    {
        slug: "doi-lon-0",
        article: "doi-lon-0-giu-tron-gia-tri",
        ended: false,
        status: "ĐANG DIỄN RA",
        title: "Đổi lớn 0%.\nGiữ trọn gi\xe1 trị.",
        short: "Đổi lớn 0%",
        period: "\xc1p dụng từ 02/10/2026 đến khi c\xf3 th\xf4ng b\xe1o mới.",
        validFrom: "2026-10-02",
        desc: "Đổi trang sức theo ch\xednh s\xe1ch giữ nguy\xean gi\xe1 trị sản phẩm cũ, với điều kiện \xe1p dụng của An Thư.",
        cta: "Xem ch\xednh s\xe1ch đổi lớn",
        shortCta: "Xem ch\xednh s\xe1ch"
    },
    {
        slug: "don-anh-trang-vang",
        article: "don-anh-trang-vang-anthu-trao-toa-sang",
        ended: true,
        status: "Đ\xc3 KẾT TH\xdaC \xb7 TH\xc1NG 9/2026",
        title: "Đ\xf3n \xe1nh trăng v\xe0ng,\nAn Thư trao tỏa s\xe1ng.",
        short: "Đ\xf3n \xe1nh trăng v\xe0ng",
        period: "Th\xe1ng 9/2026",
        desc: "Chương tr\xecnh m\xf9a Trung thu đ\xe3 kết th\xfac.",
        cta: "Xem lại chương tr\xecnh"
    }, 
];


/***/ })

}]);